import axios from 'axios';
import React, { useEffect, useRef } from 'react';
import cx from './calendar.module.scss';
import { scheduleicon } from 'src/assets/images';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { addPaymentDetailToDemoDay, clearDemoDay } from 'src/store/venture/venture.slice';
import { useUrlParamValue } from 'src/hooks';
import { openPopup } from 'src/store/common/common.slice';

export default function Calendar() {
    const calendlyEmbedRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { paramValue } = useUrlParamValue();
    const { demoDay } = useAppSelector(
        (store) => store.venture
    );

    const ventureVerseId: string = paramValue({ paramName: 'id' }) as string;    
    useEffect(() => {
        if (demoDay && demoDay !== 'undefined' && demoDay?.demoDayProgress !== 'Pitch Deck') {
            navigate('/demo-day')
        }
    }, [demoDay])
    useEffect(() => {
        // Load the Calendly script
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.body.appendChild(script);

        // Set up event listener for booking success
        const handleMessage = (e) => {
            if (e.data.event && e.data.event.indexOf('calendly') === 0) {
                // Handle the Calendly events
                if (e.data.event === 'calendly.event_scheduled') {
                    const bookingDetails = e.data.payload;
                    saveBookingToDatabase(bookingDetails);
                }
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            // Clean up
            document.body.removeChild(script);
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    // Function to save booking details to your database
    const saveBookingToDatabase = async (bookingDetails) => {
        const payload = {
            ventureVerseId,
            eventURI: bookingDetails?.event?.uri,
            inviteeURI: bookingDetails?.invitee?.uri
        }
        if (ventureVerseId) {
            dispatch(addPaymentDetailToDemoDay(payload)).then((response) => {
                if (response?.status === 200) {
                    dispatch(
                        openPopup({
                            popupMessage: 'Your booking is confirmed! Your slot has been successfully reserved.',
                            popupType: 'success'
                        })
                    );
                    dispatch(clearDemoDay())
                    navigate(`/demo-day-register/success?id=${ventureVerseId}`, { replace: true })
                }
            })
        }
    };
    return (
        <div className={cx.container}>
            <div className={cx.bookingDetails}>
                <h2>Book A Slot<br />For Round 1</h2>
                <div className={cx.timeTag}>
                    <img src={scheduleicon} alt="Clock Icon" />
                    <span>30 mins</span>
                </div>
                <p className={cx.description}>
                    Ready to take the first step? Schedule your 1:1 interaction to showcase your startup, share your vision, and make your mark.
                </p>
                <p className={cx.subHeader}>In this round, we’ll explore:</p>
                <ul className={cx.pointsList}>
                    <li>✓ Your idea & problem-solving approach</li>
                    <li>✓ Team background</li>
                    <li>✓ Initial traction or prototype (if any)</li>
                </ul>
                <p className={cx.note}>Spots are limited — pick a date that works best for you!</p>
            </div>
            <div className={cx.calendar}>
                <div
                    ref={calendlyEmbedRef}
                    className={`calendly-inline-widget ${cx.calendarContainer}`}
                    data-url={process.env.REACT_APP_CALENDALY_URL}
                    style={{ minWidth: '100%', height: '100%', background: '#fff' }}
                />
            </div>
        </div>
    )
}
